import { render, staticRenderFns } from "./City.vue?vue&type=template&id=56134722&"
import script from "./City.vue?vue&type=script&lang=js&"
export * from "./City.vue?vue&type=script&lang=js&"
import style0 from "./City.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports